export const VALID_DATA_FOR_TELESHOPPING = 'VALID_DATA_FOR_TELESHOPPING';
export const VALIDATE_TELESHOPPING_ERROR = 'VALIDATE_TELESHOPPING_ERROR';
export const RESET_TELESHOPPING_DATA = 'RESET_TELESHOPPING_DATA';
export const SET_DATA_TELESHOPPING_REGISTER = 'SET_DATA_TELESHOPPING_REGISTER';